import { Search } from 'lucide-react';
import { useStore } from '../../store/useStore';

const FILTERS = [
  { id: 'all', label: '全部' },
  { id: 'telegram', label: 'TG' },
  { id: 'whatsapp', label: 'WA' },
  { id: 'wecom', label: '企微' },
  { id: 'teams', label: 'Teams' },
  { id: 'email', label: '邮件' },
  { id: 'facebook', label: 'FB' },
];

const PLATFORM_COLORS = {
  telegram: '#229ED9',
  whatsapp: '#25D366',
  wecom: '#07C160',
  teams: '#6264A7',
  email: '#EA4335',
  facebook: '#1877F2',
  instagram: '#E1306C',
};

const PLATFORM_LETTERS = {
  telegram: 'T', whatsapp: 'W', wecom: '微', teams: 'M', email: '@', facebook: 'f', instagram: 'I'
};

export default function ConversationList() {
  const { activeConvId, conversationStatus, filterPlatform, searchQuery, contacts,
    setActiveConv, setConversationStatus, setFilterPlatform, setSearchQuery, getFilteredConvs, loading, error, wsStatus } = useStore();

  const convs = getFilteredConvs();

  return (
    <div className="conv-panel">
      <div className="conv-panel-header">
        <div className="conv-panel-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
          <span>全部会话</span>
          <span style={{ fontSize: 11, color: wsStatus === 'connected' ? 'var(--c-wa)' : 'var(--c-text-3)' }}>
            {wsStatus === 'connected' ? '实时' : '离线'}
          </span>
        </div>
        <div className="search-bar">
          <Search size={14} color="var(--c-text-3)" />
          <input
            placeholder="搜索客户、消息..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="platform-filters">
        {[
          { id: 'open', label: '打开' },
          { id: 'closed', label: '已关闭' },
        ].map(item => (
          <button
            key={item.id}
            className={`platform-filter ${conversationStatus === item.id ? 'active' : ''}`}
            onClick={() => setConversationStatus(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="platform-filters">
        {FILTERS.map(f => (
          <button
            key={f.id}
            className={`platform-filter ${filterPlatform === f.id ? 'active' : ''}`}
            onClick={() => setFilterPlatform(f.id)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="conv-list">
        {loading && (
          <div style={{ padding: '12px 16px', color: 'var(--c-text-3)', fontSize: 12 }}>
            正在加载会话...
          </div>
        )}
        {error && (
          <div style={{ margin: '8px 12px', padding: '8px 10px', borderRadius: 6, background: '#FDECEA', color: '#9C1B14', fontSize: 12 }}>
            {error}
          </div>
        )}
        {convs.length === 0 && (
          <div style={{ padding: '24px 16px', textAlign: 'center', color: 'var(--c-text-3)', fontSize: 13 }}>
            {conversationStatus === 'closed' ? '没有已关闭会话' : '没有找到匹配的会话'}
          </div>
        )}
        {convs.map(conv => {
          const contact = contacts[conv.contactId];
          if (!contact) return null;
          const platColor = PLATFORM_COLORS[conv.platform];
          const platLetter = PLATFORM_LETTERS[conv.platform];
          return (
            <div
              key={conv.id}
              className={`conv-item ${activeConvId === conv.id ? 'active' : ''}`}
              onClick={() => setActiveConv(conv.id)}
            >
              <div className="contact-avatar" style={{ background: contact.avatarBg, color: contact.avatarColor }}>
                {contact.initials}
                <div className="platform-badge" style={{ background: platColor }}>
                  {platLetter}
                </div>
              </div>
              <div className="conv-meta">
                <div className="conv-top">
                  <span className="conv-name">{contact.name}</span>
                  <span className="conv-time">{conv.lastTime}</span>
                </div>
                <div className="conv-preview">
                  {conv.sourceScene && <span className="conv-source-scene">{conv.sourceScene}</span>}
                  <span>{conv.lastMessage}</span>
                </div>
              </div>
              {conv.unread > 0 && (
                <div className="unread-dot" style={{ flexShrink: 0, marginTop: 4 }}>
                  {conv.unread}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
